import { isWorkoutStatusDragBlocked } from '../../../components/badge/workout-status-badge';
import { WorkoutWithCycleAndSession } from '../types';

export type ResolvedWorkoutMove = {
  workoutId: string;
  currentAssignedDate: string | null;
  newAssignedDate: string;
};

/**
 * What a drag in the All view means. The dnd-kit active id is the dragged
 * workout's id and the over id is the day cell's ISO date; anything else
 * (a drop that misses a day cell, an unknown workout) is not a move.
 *
 * A workout whose status blocks drag (read-only, or in progress — its
 * logged history belongs to the original date) is not a move either: its
 * drag started only to warn (see BlockAllView's onDragStart), so the drop
 * leaves the workout where it was.
 *
 * The block bounds and the same-date no-op are enforced downstream by the
 * shared write path (useMoveWorkoutDate), so both surfaces stay identical.
 */
export function resolveAllViewDragEnd(args: {
  activeId: string;
  overId: string | null;
  workouts: WorkoutWithCycleAndSession[];
}): ResolvedWorkoutMove | null {
  if (!args.overId) return null;
  const workout = args.workouts.find((w) => w.workoutId === args.activeId);
  if (!workout) return null;
  if (isWorkoutStatusDragBlocked(workout.status)) return null;
  return {
    workoutId: workout.workoutId,
    currentAssignedDate: workout.assignedDate,
    newAssignedDate: args.overId,
  };
}
